// src/components/TopperSection.jsx
import React from 'react';
import logo from "../../assets/Group18.png";
import styled from "styled-components";

const TopperContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    top: 104px;
    width: 100%;
`;

const Topper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    padding: 60px;
    padding-left: 385px;
    width: 100%;
    background: #ffffff;
`;

const TopperImage = styled.img`
    position: absolute;
    left: 186px;
    top: 140px;
    transform: translateY(-50%);
    width: 156px;
    height: auto;
`;

const TopperSubTitle = styled.h1`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 35px;
    color: #707070;
    text-align: left;
    letter-spacing: 0px;
    line-height: 18px;
    margin: 0 0 20px 0;
`;

const TopperTitle = styled.h1`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 50px;
    color: #484949;
    text-align: center;
    letter-spacing: 0px;
    line-height: 69px;
    margin: 0 0 20px 0;
`;

const TopperSection = () => {
    return (
        <TopperContainer>
            <Topper>
                <TopperTitle>Welcome to the M-List</TopperTitle>
                <TopperSubTitle>Blurb about the list</TopperSubTitle>
                <TopperImage src={logo} alt="M List Logo"/>
            </Topper>
        </TopperContainer>
    );
};

export default TopperSection;
